<script setup lang="ts">
import { useAuth } from "~/composables/auth/useAuth";
import { useFetchProfile } from "~/composables/auth/useFetchProfile";
import { useListProjects } from "~/composables/projects/useListProjects";
import { useGetWorkspace } from "~/composables/workspaces/useGetWorkspace";
import { useListWorkspaces } from "~/composables/workspaces/useListWorkspaces";

const { isHelpSlideoverOpen } = useDashboard();
const { isDashboardSearchModalOpen } = useUIState();
const { metaSymbol } = useShortcuts();

const { user, avatar } = useFetchProfile();
const workspaceId = useCookie("workspace_id");
const { logout } = useAuth();
const { workspace } = useGetWorkspace();
const { workspaces } = useListWorkspaces();
const { projects } = useListProjects();

const actions = [
  {
    label: "Create workspace",
    icon: "i-heroicons-plus-circle",
    click: async () => {
      navigateTo("/onboarding/create-workspace");
    },
  },
  // {
  //   label: 'Manage workspaces',
  //   icon: 'i-heroicons-cog-8-tooth',
  //   click: () => {
  //     console.log("manage workspaces")
  //   }
  // }
];

const items = computed(() => [
  [
    {
      slot: "account",
      label: "",
      disabled: true,
    },
  ],

  [
    ...workspaces.value.map((w) => {
      return {
        label: w.name,
        id: w.id,
        to: `/${w.slug}`,
        selected: w.id === workspace.value.id,
        slot: "workspace",
        click: () => {
          projects.value = [];
          workspaceId.value = w.id;
          workspace.value = w;
        },
        avatar: {
          src: "https://avatars.githubusercontent.com/u/23360933?s=200&v=4",
        },
      };
    }),
    ...actions,
  ],
  [
    {
      label: "Command menu",
      icon: "i-heroicons-command-line",
      shortcuts: [metaSymbol.value, "K"],
      click: () => {
        isDashboardSearchModalOpen.value = true;
      },
    },
    {
      label: "Help & Support",
      icon: "i-heroicons-question-mark-circle",
      shortcuts: ["?"],
      click: () => (isHelpSlideoverOpen.value = true),
    },
  ],
  [
    {
      label: "Documentation",
      icon: "i-heroicons-book-open",
      to: "/docs",
      target: "_blank",
    },
  ],
  [
    {
      label: "Sign out",
      icon: "i-heroicons-arrow-left-on-rectangle",
      click: logout,
    },
  ],
]);

</script>

<template>
  <UDropdown mode="click" :items="items" :ui="{ width: 'w-full', item: { disabled: 'cursor-text select-text' } }"
    :popper="{ strategy: 'absolute', placement: 'top' }" class="w-full">
    <template #default="{ open }">
      <UButton color="gray" variant="ghost" class="w-full" :label="user?.forename || user?.surname || 'You'"
        :class="[open && 'bg-gray-50 dark:bg-gray-800']">
        <template #leading>
          <UAvatar :src="avatar" :alt="`${user?.forename || ''} ${user?.surname || ''}`" size="2xs" />
        </template>

        <template #trailing>
          <UIcon name="i-heroicons-ellipsis-vertical" class="w-5 h-5 ml-auto" />
        </template>
      </UButton>
    </template>

    <template #workspace={item}>
      <UAvatar :src="item.avatar.src" size="xs" />
      <span class="truncate text-md">{{ item.label }}</span>
      <UIcon name="i-heroicons-check" class="w-5 h-5 ml-auto" v-if="item.selected" />
    </template>

    <template #account>
      <div class="text-left">
        <p>
          Signed in as
        </p>
        <p class="truncate font-medium text-gray-900 dark:text-white">
          {{ user.email }}
        </p>
      </div>
    </template>
  </UDropdown>
</template>
